export default __webpack_public_path__ + "static/media/services-nutrition.c0f2fb16.jpg";